import { render, staticRenderFns } from "./ProfitSummary.vue?vue&type=template&id=91b3167c"
import script from "./ProfitSummary.vue?vue&type=script&lang=js"
export * from "./ProfitSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91b3167c')) {
      api.createRecord('91b3167c', component.options)
    } else {
      api.reload('91b3167c', component.options)
    }
    module.hot.accept("./ProfitSummary.vue?vue&type=template&id=91b3167c", function () {
      api.rerender('91b3167c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/PanelGroup/ProfitSummary.vue"
export default component.exports